export default function Maps_Basic() {
  return (
    <div>
      <h1>Maps_Basic Component</h1>
    </div>
  );
}
